const vapehubonline = {
    id: 'vapehubonline',
    publicSiteName: 'Vape Hub Online',
    branch: process.env.NEXT_PUBLIC_SHOP_BRANCH,
    siteUrl: process.env.NEXT_PUBLIC_SITE_URL,
    googleVerification: process.env.NEXT_PUBLIC_GOOGLE_SITE_VERIFICATION,
    gaId: process.env.NEXT_PUBLIC_GA_ID,
    theme: {
        colors: {
            primary: '#258fcb',
            secondary: '#000a1a',
            color1: '#367faa',
        },
        fonts: {
            body: 'var(--font-sans)',
            heading: 'var(--font-heading)',
        },
        radius: '4px',
        header: {
            layout: 'classic',
            dark: true,
            sticky: true,
            showSearch: true,
            showAccount: true,
            showWishlist: true,
            showAnnouncementBar: true,
            transparent: false,
        }
    },
    assets: {
        favicon: '/vapehubonline/favicon.ico',
        logo: '/vapehubonline/logo.png',
    },
    features: {
        rewards: true,
        subscriptions: true,
    },
}

export default vapehubonline